//
// Menu toggle (used for navigation in .site-header)
//

// Define menu elements
const menuToggle = document.querySelector('#js-menu-toggle');
const menuContainer = document.querySelector('#js-menu-container');

// Listen for click events
document.addEventListener('click', function (event) {

    // Check if clicked element is the toggle
    if (event.target !== menuToggle) return;

    // If so, change ARIA and toggle classes used to reveal
    const open = JSON.parse(menuToggle.getAttribute('aria-expanded'));
    menuToggle.setAttribute('aria-expanded', !open);
    menuToggle.classList.toggle('js-menu-toggle--active');
    menuContainer.classList.toggle('js-menu-container--open');

}, false);
